import { render } from "./Slogan.vue?vue&type=template&id=102cc9e0&ts=true"
import script from "./Slogan.vue?vue&type=script&lang=ts"
export * from "./Slogan.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__